import moment from 'moment'
import formButton from '@/components/common/form-button/form-button.vue'
import { mapActions, mapState } from 'vuex'
import faTrash from '@fortawesome/fontawesome-free-solid/faTrash'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import { find } from 'lodash'
import softApproval from '@/components/common/soft-approval/soft-approval.vue'
import { debounce } from 'lodash'
export default {
  components: {
    formButton,
    FontAwesomeIcon,
    softApproval
  },
  props: {
    name: {
      type: String,
      required: true
    },
    createdAt: {
      type: String,
      required: true
    },
    updatedAt: {
      type: String,
      required: true
    },
    state: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    age: {
      type: String,
      required: true
    },
    softApproval: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('user', ['currentUser']),
    ...mapState('popup', ['currentPopup']),
    deleteIcon: function () {
      return faTrash
    }
  },
  methods: {
    ...mapActions('app', ['redirectToPolling']),
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('competition', ['cloneConfiguration', 'deleteCompetition', 'getOneCompetition']),
    cloneAction: debounce(function () {
      if (this.softApproval) {
        this.setCurrentPopup('softApproval')
      } else {
        this.cloneCompetition()
      }
    }, 300),
    cloneCompetition: async function (user) {
      try {
        const data = {
          id: this.id
        }
        if (user) {
          data.email = user.email
        }
        const res = await this.cloneConfiguration(data)
        this.$notify({
          text: 'Competition successfully cloned',
          type: 'success'
        })
        await this.redirectToPolling(res.data._id)
      } catch (e) {
        this.$notify({
          text: 'Error while cloning competition',
          type: 'error'
        })
      }
    },
    goToCompetition: function (e) {
      if (e.target.nodeName !== 'BUTTON' && e.target.nodeName !== 'path' && !this.currentPopup) {
        this.redirectToPolling(this.id)
      }
    },
    formatDate: function (date) {
      return moment(date).format('DD.MM.YYYY H:mm')
    },
    onDeleteCompetition: async function () {
      try {
        const competition = await this.getOneCompetition({ id: this.id })
        const user = find(competition.privileges, { user_id: this.currentUser.id })
        if (user && user.role === 'editor') {
          await this.$dialog.confirm('Are you sure you want to delete this competition')
          await this.deleteCompetition({ id: this.id })
          this.$notify({
            text: 'Competition successfully deleted',
            type: 'success'
          })
          this.$emit('onDeleteCompetition')
        } else {
          this.$notify({
            text: 'You do not have Admin permissions to this competition',
            type: 'error'
          })
        }
      } catch (error) {
        this.$notify({
          text: 'Error while deleting competition',
          type: 'error'
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/cards/card-draft/card-draft.js